module.exports = __webpack_public_path__ + "img/police.32f0dff7.png";